module.exports = __webpack_public_path__ + "static/media/searc_empty_state.e0da6ef6.png";